import React from 'react';
import JoinWaitlistSummary from "./JoinWaitlistSummary";
import HowItWorks from "./HowItWorks";
import {FlexColumnSection} from "../../../styles/globalStyles";
import useScreenSize from "../../../helpers/hooks/useScreenSize";

const JoinSuccessDetails = (props) => {
    const { waitlistData, coachName } = props;
    const {isMobile} = useScreenSize();
    return (
        <FlexColumnSection gap={'16px'} flex={'unset'} style={{width: isMobile ? '100%' : '520px'}}>
            <JoinWaitlistSummary values={waitlistData} coach_name={coachName} showAllRange={true}/>
            <HowItWorks/>
        </FlexColumnSection>
    );
};

export default JoinSuccessDetails;